import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Stack, Switch, FormControlLabel } from "@mui/material";
import { Card, CardBody, Row, Col, Form, Button, ButtonGroup, Modal } from "react-bootstrap";
import Select from "react-select";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import * as yup from "yup";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { nanoid } from "nanoid";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { getDiscountValue, NumberFormat, getInfoAdminSystem, filterTextAndNum, getPrefixName, WDA } from "utils/HelperFunction";
import { ModalAllder } from "layouts/ModalAllder";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { invoice } from "../../redux/handlers/invoice/invoice.handler";
import { getInvoiceByID } from "../../redux/handlers/invoice/getInvoiceByID.handler";
// import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
// import { uploadInvoice } from "../../redux/handlers/invoice/uploadInvoice.handler";
// import {
//   createInvoice,
//   clearcreateInvoice,
// } from "../../redux/handlers/invoice/createInvoice.handler";
// import {
//   updateInvoice,
//   clearupdateInvoice,
// } from "../../redux/handlers/invoice/updateInvoice.handler";
export function Invoice() {
    var dispatch = useAppDispatch();
    var businessID = null;
    var memID = null;
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                    memID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.mb_mem_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), rowData = _useState2[0], setRowData = _useState2[1];
    var invoiceReducer = useAppSelector(function(state) {
        return state.invoiceReducer;
    });
    useEffect(function() {
        setIsLoading(invoiceReducer.isFetching);
        if (invoiceReducer.data) {
            var data = invoiceReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        invoiceReducer
    ]);
    useEffect(function() {
        dispatch(invoice(parseInt(businessID), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        if (filterText) {
            setRowData(filteredItems.filter(function(item) {
                return item.inv_invoice_code && item.inv_invoice_code.toLowerCase().includes(filterText.toLowerCase()) || item.inv_invoice_branchname && item.inv_invoice_branchname.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        rowData,
        filterText
    ]);
    var columns = [
        {
            name: "เลขที่ใบเสร็จ",
            selector: function(row) {
                return row.inv_invoice_code;
            },
            center: "true",
            width: "160px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/invoice/edit/" + row.inv_invoice_id,
                        children: row.inv_invoice_code ? row.inv_invoice_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "อ้างอิงใบแจ้งหนี้",
            selector: function(row) {
                return row.BlBilling ? row.BlBilling.bl_billing_code : "-";
            },
            center: "true",
            width: "160px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/billing/edit/" + row.inv_invoice_billid,
                        children: row.BlBilling ? row.BlBilling.bl_billing_code : "-"
                    })
                });
            }
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.inv_invoice_businesstype ? row.inv_invoice_businesstype == 1 ? row.inv_invoice_fname ? row.inv_invoice_fname + " " + row.inv_invoice_lname : "-" : row.inv_invoice_name ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.inv_invoice_name,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.inv_invoice_taxid
                        })
                    ]
                }) : "-" : "-";
            },
            width: "200px"
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.inv_invoice_issuedate ? moment(row.inv_invoice_issuedate).format("DD/MM/YYYY") : "-";
            },
            center: "true"
        },
        {
            name: "จำนวนสินค้า",
            center: "true",
            selector: function(row) {
                return row.inv_invoice_totallist ? row.inv_invoice_totallist : "0";
            }
        },
        {
            name: "มูลค่าสุทธิ",
            selector: function(row) {
                return row.inv_invoice_totalnet ? NumberFormat(row.inv_invoice_totalnet, 2) : "0.00";
            },
            center: "true"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสร็จรับเงิน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: "ใบเสร็จรับเงิน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 7,
                                        children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                            data: rowData,
                                            filename: "ผู้จัดจำหน่าย"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "horizontal",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control me-3",
                                                placeholder: "ค้นหาเลขใบเสร็จรับเงิน",
                                                onKeyUp: function(e) {
                                                    return setFilterText(e.target.value);
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
export function InvoiceManage() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var poID = useParams().poID;
    var _useState = _sliced_to_array(useState({
        inv_invoice_vattype: 1,
        inv_invoice_issuedate: new Date(),
        inv_invoice_status: 1,
        inv_invoice_discounttype: 1,
        inv_invoice_tax: 0,
        inv_invoice_vat: 0
    }), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), formdisabled = _useState1[0], setFormdisabled = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), stepper = _useState2[0], setStepper = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), supplierInfos = _useState3[0], setSupplierInfos = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), productRow = _useState4[0], setProductRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumrowNoDiscount = _useState5[0], setSumrowNoDiscount = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumrowBeforeVat = _useState6[0], setSumrowBeforeVat = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState7[0], setSumrowTotalNet = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), sumrowQty = _useState8[0], setSumrowQty = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), sumrowPrice = _useState9[0], setSumrowPrice = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), sumrowDiscount = _useState10[0], setSumrowDiscount = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), sumDiscount = _useState11[0], setSumDiscount = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), sumrowVat = _useState12[0], setSumrowVat = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), sumrowTax = _useState13[0], setSumrowTax = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), docPath = _useState14[0], setDocPath = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), docPathDel = _useState15[0], setDocPathDel = _useState15[1];
    var _useState16 = _sliced_to_array(useState(""), 2), payDate = _useState16[0], setPayDate = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), payment = _useState17[0], setPayment = _useState17[1];
    var _useState18 = _sliced_to_array(useState(true), 2), taxSwitch = _useState18[0], setTaxSwitch = _useState18[1];
    var _useState19 = _sliced_to_array(useState(0), 2), sumVat = _useState19[0], setSumVat = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), remark = _useState20[0], setRemark = _useState20[1];
    var _useState21 = _sliced_to_array(useState(false), 2), textsuccess = _useState21[0], setTextsuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState(false), 2), modalsuccess = _useState22[0], setModalsuccess = _useState22[1];
    var _useState23 = _sliced_to_array(useState([]), 2), productRowDel = _useState23[0], setProductRowDel = _useState23[1];
    var schema = yup.object().shape({});
    var _useState24 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState24[0], setPartnerInfo = _useState24[1];
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    var optionsMstPriceType = [
        {
            value: 1,
            label: "รวมภาษี"
        },
        {
            value: 2,
            label: "ไม่รวมภาษี"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var optionsVat = [
        {
            label: "ไม่มี",
            value: 0
        },
        {
            label: "3%",
            value: 3
        },
        {
            label: "7%",
            value: 7
        },
        {
            label: "10%",
            value: 10
        }
    ];
    var _useState25 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState25[0], setColumDisplay = _useState25[1];
    var getInvoiceByIDReducer = useAppSelector(function(state) {
        return state.getInvoiceByIDReducer;
    });
    useEffect(function() {
        if (dataID) {
            dispatch(getInvoiceByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        dataID
    ]);
    useEffect(function() {
        setIsLoading(getInvoiceByIDReducer.isFetching);
        if (dataID) {
            if (getInvoiceByIDReducer.data) {
                var getData = getInvoiceByIDReducer.data.data;
                console.log("getInvoiceByIDReducer", getData);
                setStepper(getData.inv_invoice_status == 2 ? getData.inv_invoice_status + 1 : 1);
                setTaxSwitch(getData.inv_invoice_taxstatus == 1 ? true : false);
                var _obj;
                setFormdata((_obj = {
                    inv_invoice_id: getData.inv_invoice_id,
                    inv_invoice_discount: getData.inv_invoice_discount ? getData.inv_invoice_discount : 0,
                    inv_invoice_discountreal: getData.inv_invoice_discountreal ? getData.inv_invoice_discountreal : 0,
                    inv_invoice_discounttype: getData.inv_invoice_discounttype ? getData.inv_invoice_discounttype : 1,
                    inv_invoice_pricediscount: getData.inv_invoice_pricediscount ? getData.inv_invoice_pricediscount : 0,
                    inv_invoice_taxinvoice: getData.inv_invoice_taxinvoice ? getData.inv_invoice_taxinvoice : 0,
                    inv_invoice_taxstatus: getData.inv_invoice_taxstatus ? getData.inv_invoice_taxstatus : 0,
                    inv_invoice_totallist: getData.inv_invoice_totallist,
                    inv_invoice_totalnet: getData.inv_invoice_totalnet ? getData.inv_invoice_totalnet : 0,
                    inv_invoice_totalnettax: getData.inv_invoice_totalnettax ? getData.inv_invoice_totalnettax : 0,
                    inv_invoice_totalprice: getData.inv_invoice_totalprice ? getData.inv_invoice_totalprice : 0,
                    inv_invoice_totaltax: getData.inv_invoice_totaltax ? getData.inv_invoice_totaltax : 0,
                    inv_invoice_totalvat: getData.inv_invoice_totalvat ? getData.inv_invoice_totalvat : 0,
                    inv_invoice_code: getData.inv_invoice_code,
                    inv_invoice_issuedate: getData.inv_invoice_issuedate ? new Date(getData.inv_invoice_issuedate) : "",
                    inv_invoice_vattype: getData.inv_invoice_vattype,
                    inv_invoice_status: getData.inv_invoice_status ? getData.inv_invoice_status : 1,
                    inv_invoice_refercode: getData.inv_invoice_refercode ? getData.inv_invoice_refercode : "",
                    inv_invoice_refer: getData.BlBilling ? getData.BlBilling.bl_billing_code : "",
                    inv_invoice_categoryid: getData.inv_invoice_categoryid,
                    inv_invoice_suffixname: getData.inv_invoice_suffixname,
                    inv_invoice_vatcode: getData.inv_invoice_vatcode,
                    inv_invoice_name: getData.inv_invoice_name,
                    inv_invoice_address: getData.inv_invoice_address,
                    inv_invoice_fname: getData.inv_invoice_fname,
                    inv_invoice_lname: getData.inv_invoice_lname,
                    inv_invoice_mainfname: getData.inv_invoice_mainfname,
                    inv_invoice_mainlname: getData.inv_invoice_mainlname,
                    inv_invoice_mainphone: getData.inv_invoice_mainphone,
                    inv_invoice_mainemail: getData.inv_invoice_mainemail,
                    inv_invoice_provinceid: getData.inv_invoice_provinceid,
                    inv_invoice_subprovinceid: getData.inv_invoice_subprovinceid,
                    inv_invoice_zipcodeid: getData.inv_invoice_zipcodeid,
                    inv_invoice_districtid: getData.inv_invoice_districtid,
                    inv_invoice_comprefixid: getData.inv_invoice_comprefixid,
                    inv_invoice_comprefixname: getData.inv_invoice_comprefixname,
                    inv_invoice_taxid: getData.inv_invoice_taxid,
                    inv_invoice_businesstype: getData.inv_invoice_businesstype,
                    inv_invoice_branchname: getData.inv_invoice_branchname,
                    inv_invoice_memid: getData.inv_invoice_memid,
                    inv_invoice_vat: getData.inv_invoice_vat
                }, _define_property(_obj, "inv_invoice_totalvat", getData.inv_invoice_totalvat), _define_property(_obj, "inv_invoice_tax", getData.inv_invoice_tax), _define_property(_obj, "inv_invoice_totaltax", getData.inv_invoice_totaltax), _define_property(_obj, "inv_invoice_paytype", getData.inv_invoice_paytype), _obj));
                var pay = [];
                // getData.map((ele) =>
                pay.push({
                    id: nanoid(),
                    inv_invoice_paytype: getData.inv_invoice_paytype,
                    inv_invoice_totalnet: getData.inv_invoice_totalnet,
                    inv_invoice_ramark: getData.inv_invoice_ramark,
                    inv_invoice_taxstatus: getData.inv_invoice_taxinvoice,
                    inv_invoice_issuedate: getData.inv_invoice_issuedate
                });
                // );
                setPayment(pay);
                setSumrowTax(getData.inv_invoice_totaltax);
                setSumrowVat(getData.inv_invoice_totalvat);
                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                    companyName: getData.inv_invoice_businesstype == 2 ? filterTextAndNum(getData.inv_invoice_comprefixname ? getData.inv_invoice_comprefixname : "") + filterTextAndNum(getData.inv_invoice_name ? getData.inv_invoice_name : "") + filterTextAndNum(getData.inv_invoice_suffixname ? getData.inv_invoice_suffixname : "") : filterTextAndNum(getData.inv_invoice_prefixid == 1 && "นาย" || getData.inv_invoice_prefixid == 2 && "นาง" || getData.inv_invoice_prefixid == 3 && "นางสาว" || getData.inv_invoice_prefixid == 4 && "ไม่ระบุ" || getData.inv_invoice_prefixid == "" && "") + " " + filterTextAndNum(getData.inv_invoice_fname) + " " + filterTextAndNum(getData.inv_invoice_lname),
                    companyBranch: getData.inv_invoice_branchname ? getData.inv_invoice_branchname : "",
                    companyTaxId: getData.inv_invoice_taxid ? getData.inv_invoice_taxid : "",
                    companyAddress: getData.inv_invoice_address,
                    companyProvince: getData.Invprovinceid ? JSON.parse(getData.Invprovinceid.province_name).th : "",
                    companyDistrict: getData.Invdistrictid ? JSON.parse(getData.Invdistrictid.subdistrict_name).th : "",
                    companySubDistrict: getData.Invsubprovinceid ? JSON.parse(getData.Invsubprovinceid.district_name).th : "",
                    companyZipCode: getData.inv_invoice_zipcodeid ? getData.inv_invoice_zipcodeid : "",
                    contractName: getData.inv_invoice_mainfname && getData.inv_invoice_mainlname ? getData.inv_invoice_mainfname + " " + getData.inv_invoice_mainlname : "",
                    contactPhone: getData.inv_invoice_mainphone ? getData.inv_invoice_mainphone : "",
                    contactEmail: getData.inv_invoice_mainemail ? getData.inv_invoice_mainemail : ""
                }));
                setSumrowTotalNet(getData.inv_invoice_totalprice);
                var arrFile = [];
                getData === null || getData === void 0 ? void 0 : getData.InvFile.map(function(ele) {
                    return arrFile.push({
                        id: nanoid(),
                        inv_file_url: ele.inv_file_url,
                        type: "update",
                        inv_file_id: ele.inv_file_id
                    });
                });
                setDocPath(arrFile);
                var datalistData = [];
                getData.InvDetail.map(function(ele) {
                    return datalistData.push({
                        rowID: nanoid(),
                        inv_detail_amount: ele.inv_detail_amount ? ele.inv_detail_amount : 0,
                        inv_detail_id: ele.inv_detail_id ? ele.inv_detail_id : "",
                        inv_detail_discount: ele.inv_detail_discount ? ele.inv_detail_discount : 0,
                        inv_detail_discountreal: ele.inv_detail_discountreal ? ele.inv_detail_discountreal : 0,
                        inv_detail_discounttype: ele.inv_detail_discounttype ? ele.inv_detail_discounttype : 1,
                        inv_detail_name: ele.inv_detail_name ? ele.inv_detail_name : "",
                        inv_detail_net: ele.inv_detail_net ? ele.inv_detail_net : 0,
                        inv_detail_price: ele.inv_detail_price ? ele.inv_detail_price : 0,
                        inv_detail_pricediscount: ele.inv_detail_pricediscount ? ele.inv_detail_pricediscount : 0,
                        inv_detail_remark: ele.inv_detail_remark ? ele.inv_detail_remark : "",
                        inv_detail_tax: ele.inv_detail_tax ? ele.inv_detail_tax : 0,
                        inv_detail_taxtype: ele.inv_detail_taxtype ? ele.inv_detail_taxtype : 0,
                        inv_detail_totalprice: ele.inv_detail_totalprice ? ele.inv_detail_totalprice : 0,
                        inv_detail_unit: ele.inv_detail_unit ? ele.inv_detail_unit : "",
                        inv_detail_vat: ele.inv_detail_vat ? ele.inv_detail_vat : 0,
                        inv_detail_vatnet: ele.inv_detail_vatnet ? ele.inv_detail_vatnet : 0,
                        inv_detail_vatprice: ele.inv_detail_vatprice ? ele.inv_detail_vatprice : 0,
                        type: "update"
                    });
                });
                setProductRow(datalistData);
                setSumDiscount(getData.inv_invoice_discounttype == 1 ? getData.inv_invoice_discount : getData.inv_invoice_totalprice * getData.inv_invoice_discount / 100);
                setRemark(getData.inv_invoice_ramark ? getData.inv_invoice_ramark : "");
            }
        }
    }, [
        getInvoiceByIDReducer
    ]);
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    useEffect(function() {
        if (!dataID) {
            var pay = [];
            pay.push({
                id: nanoid(),
                inv_invoice_issuedate: moment().format("DD/MM/YYYY"),
                inv_invoice_paytype: 1,
                inv_invoice_totalnet: sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax,
                inv_invoice_ramark: "",
                inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
                type: "create"
            });
            setPayment(pay);
        }
    }, [
        dataID,
        sumrowTotalNet,
        sumDiscount,
        sumrowVat,
        sumrowTax
    ]);
    var dataSteps = [
        "สร้างใบเสร็จ",
        "รับชำระ",
        "เสร็จสิ้น"
    ];
    var optionsMstTax = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ];
    var optionsMstVat = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสร็จรับเงิน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: dataID ? "แก้ใบเสร็จ" : "สร้างใบเสร็จ"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: dataID ? "แก้ไขใบเสร็จ" : "สร้างใบเสร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("formdataPayload", formdataPayload);
                    console.log("values", values);
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
                                            dataLabel: dataSteps,
                                            activeStep: stepper
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "pt-3 px-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เลขที่ใบเสร็จ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_code",
                                                                            className: "form-control",
                                                                            placeholder: "RE-2410000001",
                                                                            value: values.inv_invoice_code,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: values.inv_invoice_issuedate,
                                                                            onChange: function(date) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_issuedate: date
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            value: values.inv_invoice_issuedate,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิงระบบ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_refer",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิงระบบ",
                                                                            value: values.inv_invoice_refer,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_refercode",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิง",
                                                                            value: values.inv_invoice_refercode,
                                                                            disabled: true,
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_refercode: e.target.value
                                                                                }));
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            style: {
                                                                                zIndex: 11
                                                                            },
                                                                            children: "ลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "inv_invoice_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            value: partnerInfo.companyName,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ประเภทราคา"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "inv_invoice_vattype",
                                                                            onChange: function(e) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_vattype: e.value
                                                                                }));
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            isDisabled: true,
                                                                            options: optionsMstPriceType,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: optionsMstPriceType.filter(function(item) {
                                                                                return item.value === values.inv_invoice_vattype;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ผู้จัดทำเอกสาร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "creBy",
                                                                            className: "form-control",
                                                                            placeholder: "admim",
                                                                            value: "-",
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyName
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "สาขา : ",
                                                                                        partnerInfo.companyBranch
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "ทะเบียนนิติบุคคล :",
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "tc-5",
                                                                                            children: partnerInfo.companyTaxId
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyAddress
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companySubDistrict + " " + partnerInfo.companyDistrict
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ข้อมูลผู้ติดต่อ"
                                                                        }),
                                                                        partnerInfo.contractName && partnerInfo.contractName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "ชื่อ : ",
                                                                                        partnerInfo.contractName
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "เบอร์โทรศัพท์ : ",
                                                                                        partnerInfo.contactPhone
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: [
                                                                                        "อีเมล : ",
                                                                                        partnerInfo.contactEmail
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-18 mb-2",
                                                                            children: "-"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        formdisabled: formdisabled,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        values: values,
                                        errors: errors,
                                        setFieldValue: setFieldValue,
                                        handleChange: handleChange,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsVat: optionsVat,
                                        sumrowNoDiscount: sumrowNoDiscount,
                                        setSumrowNoDiscount: setSumrowNoDiscount,
                                        sumrowBeforeVat: sumrowBeforeVat,
                                        setSumrowBeforeVat: setSumrowBeforeVat,
                                        sumrowTotalNet: sumrowTotalNet,
                                        setSumrowTotalNet: setSumrowTotalNet,
                                        sumrowQty: sumrowQty,
                                        setSumrowQty: setSumrowQty,
                                        sumrowPrice: sumrowPrice,
                                        setSumrowPrice: setSumrowPrice,
                                        sumrowDiscount: sumrowDiscount,
                                        setSumrowDiscount: setSumrowDiscount,
                                        sumDiscount: sumDiscount,
                                        setSumDiscount: setSumDiscount,
                                        sumrowVat: sumrowVat,
                                        setSumrowVat: setSumrowVat,
                                        sumrowTax: sumrowTax,
                                        setSumrowTax: setSumrowTax,
                                        docPath: docPath,
                                        setDocPath: setDocPath,
                                        docPathDel: docPathDel,
                                        setDocPathDel: setDocPathDel,
                                        columdisplay: columdisplay,
                                        setValues: setValues,
                                        remark: remark,
                                        setRemark: setRemark,
                                        poID: poID,
                                        modalObj: modalObj,
                                        setModalObj: setModalObj,
                                        setIsLoading: setIsLoading,
                                        productRowDel: productRowDel,
                                        setProductRowDel: setProductRowDel,
                                        optionsMstVat: optionsMstVat,
                                        optionsMstTax: optionsMstTax
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "px-3 !bg-[rgb(176 3 18)]",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-9",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "fs-24 fw-bold",
                                                                    children: "การรับชำะเงิน"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: values.inv_invoice_issuedate,
                                                                            disabled: true,
                                                                            onChange: function(date) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    inv_invoice_issuedate: date
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            value: values.inv_invoice_issuedate
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-2",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "row gx-xl-4",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12 mb-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-20 tc-5 fw-bold",
                                                                children: "รายการชำระเงิน"
                                                            })
                                                        })
                                                    }),
                                                    payment.map(function(item, index) {
                                                        return /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            keys: index,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4 col-md-4",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-md-1",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 fw-bold pt-3",
                                                                                    children: [
                                                                                        index + 1,
                                                                                        "."
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-md-11",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เอกสาร"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            placeholder: "เลือกเอกสาร",
                                                                                            name: "inv_invoice_paytype",
                                                                                            isDisabled: true,
                                                                                            onChange: function(e) {
                                                                                                setPayment(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            inv_invoice_paytype: e.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            className: "w-100 select-st-1",
                                                                                            options: optionsMstPayment,
                                                                                            value: optionsMstPayment.filter(function(d) {
                                                                                                return d.value == item.inv_invoice_paytype;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-3",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จำนวนเงินที่ชำระ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "inv_invoice_totalnet",
                                                                                className: "form-control",
                                                                                placeholder: "จำนวนเงินที่ชำระ",
                                                                                value: NumberFormat(item.inv_invoice_totalnet, 2),
                                                                                disabled: true,
                                                                                onChange: function(e) {
                                                                                    setPayment(function(prev) {
                                                                                        return prev.map(function(el) {
                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                inv_invoice_totalnet: e.target.value
                                                                                            }) : el;
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4 col-md-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หมายเหตุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "inv_invoice_ramark",
                                                                                className: "form-control",
                                                                                placeholder: "หมายเหตุ",
                                                                                disabled: true,
                                                                                value: item.inv_invoice_ramark,
                                                                                onChange: function(e) {
                                                                                    setPayment(function(prev) {
                                                                                        return prev.map(function(el) {
                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                inv_invoice_ramark: e.target.value
                                                                                            }) : el;
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-11",
                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                    direction: "row",
                                                                    justifyContent: "space-between",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fs-20 fw-bold tc-5 mb-3",
                                                                            children: "หัก ณ ที่จ่าย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Group, {
                                                                            children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                                                                control: /*#__PURE__*/ _jsx(Switch, {
                                                                                    defaultChecked: taxSwitch
                                                                                }),
                                                                                label: "",
                                                                                disabled: true
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-9 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หัก ณ ที่จ่าย"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "inv_invoice_tax",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกหัก ณ ที่จ่าย",
                                                                                options: optionsMstTax,
                                                                                isDisabled: true,
                                                                                value: optionsMstTax.filter(function(item) {
                                                                                    return item.value === values.inv_invoice_tax;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setValues(_object_spread_props(_object_spread({}, values), {
                                                                                        inv_invoice_tax: e.value
                                                                                    })); // Update formData state
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "มูลค่าถูกหัก ณ ที่จ่าย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            className: "form-control",
                                                                            placeholder: "มูลค่าถูกหัก ณ ที่จ่าย",
                                                                            value: NumberFormat(sumrowTax, 2),
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-1"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "col-xl-3 col-md-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-end",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "tc-6 text-white py-3 px-3 !bg-[#B00412] mt-4",
                                                                            style: {
                                                                                borderRadius: 10
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "fs-20 me-10",
                                                                                    children: "รับชำระเงินรวมทั้งสิน"
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("span", {
                                                                                    className: "fs-24 ",
                                                                                    children: [
                                                                                        NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                                                                                        " ",
                                                                                        "บาท"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "fs-20 tc-7 mt-3 text-end",
                                                                        children: "ต้องรับชำระเงินอีก 0.00 บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        onClick: function(e) {
                                            navigate("/invoice");
                                        },
                                        className: "btn-st-6 me-3 btn ms-auto",
                                        children: "ยกเลิก"
                                    })
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function ProductData(param) {
    var formdisabled = param.formdisabled, productRow = param.productRow, setProductRow = param.setProductRow, values = param.values, errors = param.errors, setFieldValue = param.setFieldValue, setValues = param.setValues, optionsMstDiscountType = param.optionsMstDiscountType, optionsVat = param.optionsVat, handleChange = param.handleChange, columdisplay = param.columdisplay, poID = param.poID, sumrowNoDiscount = param.sumrowNoDiscount, setSumrowNoDiscount = param.setSumrowNoDiscount, sumrowBeforeVat = param.sumrowBeforeVat, setSumrowBeforeVat = param.setSumrowBeforeVat, sumrowTotalNet = param.sumrowTotalNet, setSumrowTotalNet = param.setSumrowTotalNet, sumrowQty = param.sumrowQty, setSumrowQty = param.setSumrowQty, sumrowPrice = param.sumrowPrice, setSumrowPrice = param.setSumrowPrice, sumrowDiscount = param.sumrowDiscount, setSumrowDiscount = param.setSumrowDiscount, sumDiscount = param.sumDiscount, setSumDiscount = param.setSumDiscount, sumrowVat = param.sumrowVat, setSumrowVat = param.setSumrowVat, sumrowTax = param.sumrowTax, setSumrowTax = param.setSumrowTax, remark = param.remark, setRemark = param.setRemark, docPath = param.docPath, setDocPath = param.setDocPath, docPathDel = param.docPathDel, setDocPathDel = param.setDocPathDel, modalObj = param.modalObj, setModalObj = param.setModalObj, setIsLoading = param.setIsLoading, productRowDel = param.productRowDel, setProductRowDel = param.setProductRowDel, optionsMstVat = param.optionsMstVat, optionsMstTax = param.optionsMstTax;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), collapse = _useState1[0], setCollapse = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), customSort = _useState2[0], setCustomSort = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), rowCount = _useState3[0], setRowCount = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState4[0], setOptionsWarehouse = _useState4[1];
    // const handlePreviewFile = (e) => {
    //   if (e.target.files[0]) {
    //     const formData = new FormData();
    //     formData.append("upload_tmp_invoice", e.target.files[0]);
    //     dispatch(uploadInvoice(formData, { modalObj, setModalObj }));
    //     setTextImg("doc");
    //   }
    // };
    // const uploadInvoiceReducer = useAppSelector(
    //   (state) => state.uploadInvoiceReducer
    // );
    // useEffect(() => {
    //   if (textImg == "doc") {
    //     setIsLoading(uploadInvoiceReducer.isFetching);
    //     if (uploadInvoiceReducer.data) {
    //       console.log("uploadInvoiceReducer", uploadInvoiceReducer.data.data);
    //       setDocPath((prev) => [
    //         ...prev,
    //         {
    //           id: nanoid(),
    //           inv_file_url: uploadInvoiceReducer.data.data,
    //           type: "create",
    //         },
    //       ]);
    //       setTextImg("");
    //     }
    //   }
    // }, [uploadInvoiceReducer]);
    var deleteDocument = function(removeId, item) {
        setDocPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                inv_file_id: item.inv_file_id
            };
            setDocPathDel(_to_consumable_array(docPathDel).concat([
                del
            ]));
        }
    };
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 1200,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState5[0], setModal = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-sort"
    }), 2), modalSort = _useState6[0], setModalSort = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState7[0], setModalLoadDocument = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDisplayColumn = _useState8[0], setModalDisplayColumn = _useState8[1];
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceVat = 0;
        var ums = 0;
        var discount = 0;
        var pricetax = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.inv_detail_amount);
            var productPrice = parseFloat(pd.inv_detail_price);
            var productDiscount = parseFloat(pd.inv_detail_discount);
            var productVat = parseFloat(pd.inv_detail_vatprice);
            var productTax = parseFloat(pd.inv_detail_tax);
            var disType = parseFloat(pd.inv_detail_discounttype);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productPrice * productQty;
            }
            if (hasValidPrice) {
                price += productPrice;
                discount += productDiscount;
            }
            if (hasValidQty && hasValidPrice) {
                priceBeforeVat += disType == 1 ? (productPrice - productDiscount) * productQty : productPrice - productPrice * productDiscount / 100;
                priceVat += productVat;
                pricetax += productTax;
            }
            setSumrowNoDiscount(ums);
            setSumrowQty(qty);
            setSumrowPrice(price);
            setSumrowDiscount(discount);
            setSumrowBeforeVat(priceBeforeVat);
            setSumrowTotalNet(priceVat && pricetax && parseFloat(priceBeforeVat + priceVat - pricetax) || priceVat && parseFloat(priceBeforeVat + priceVat) || pricetax && parseFloat(priceBeforeVat - pricetax) || priceBeforeVat && parseFloat(priceBeforeVat));
        // setSumrowVat(priceVat);
        // setSumrowTax(pricetax);
        });
    };
    useEffect(function() {
        sumQty(productRow);
    }, [
        productRow
    ]);
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        inv_detail_name: "",
                        inv_detail_unit: "",
                        inv_detail_amount: "",
                        inv_detail_price: 0,
                        inv_detail_discounttype: 1,
                        inv_detail_discount: 0,
                        inv_detail_discountreal: 0,
                        inv_detail_pricediscount: 0,
                        inv_detail_vat: 0,
                        inv_detail_vatprice: 0,
                        inv_detail_net: 0,
                        inv_detail_remark: "",
                        inv_detail_totalprice: 0,
                        inv_detail_vatnet: 0,
                        inv_detail_taxtype: 0,
                        inv_detail_tax: 0,
                        type: "create",
                        is_checked: false
                    }
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(1);
        }
    }, []);
    var onDeleteProductRow = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(item) {
                return item.rowID !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                inv_detail_id: item.inv_detail_id
            };
            setProductRowDel(_to_consumable_array(productRowDel).concat([
                del
            ]));
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                style: {
                    overflowX: "auto",
                    maxWidth: "100%",
                    overflowY: "hidden",
                    paddingBottom: "20px"
                },
                children: /*#__PURE__*/ _jsx(DndContext, {
                    sensors: sensors,
                    collisionDetection: closestCenter,
                    modifiers: [
                        restrictToVerticalAxis
                    ],
                    children: /*#__PURE__*/ _jsx(SortableContext, {
                        items: productRow,
                        strategy: verticalListSortingStrategy,
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "column_resize_table table1 table-striped ",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 200
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#666CFF] !text-white",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#666CFF] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#B00412] !text-white",
                                                children: "ราคา/หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#B00412] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 110
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ประเภทส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่าก่อนภาษี"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่ารวมสุทธิ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หมายเหตุ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {}),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 20
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: productRow.map(function(item, index) {
                                        return /*#__PURE__*/ _jsx(Productrow, {
                                            item: item,
                                            index: index,
                                            setProductRow: setProductRow,
                                            optionsMstDiscountType: optionsMstDiscountType,
                                            optionsVat: optionsVat,
                                            customSort: customSort,
                                            rowCount: rowCount,
                                            addProductRow: addProductRow,
                                            optionsWarehouse: optionsWarehouse,
                                            values: values,
                                            onDeleteProductRow: onDeleteProductRow
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tfoot", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowQty, 0),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowPrice, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prDiscount",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowBeforeVat, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prCode",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowTotalNet, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3",
                children: /*#__PURE__*/ _jsxs("fieldset", {
                    disabled: formdisabled,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-3 pagezoom",
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3 me-3",
                                onClick: function() {
                                    return addProductRow(1);
                                },
                                disabled: true,
                                children: "เพิ่มแถว"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "discount_value",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.inv_invoice_discount,
                                                                                                    onChange: function(e) {
                                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                            inv_invoice_discount: e.target.value
                                                                                                        }));
                                                                                                        setSumDiscount(values.inv_invoice_discounttype == 1 ? e.target.value : sumrowTotalNet * e.target.value / 100);
                                                                                                    },
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    disabled: true
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "inv_invoice_discounttype",
                                                                                                    onChange: function(e) {
                                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                            inv_invoice_discounttype: e.value
                                                                                                        }));
                                                                                                        setSumDiscount(e.value == 1 ? values.inv_invoice_discount : sumrowTotalNet * values.inv_invoice_discount / 100);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2",
                                                                                                    options: optionsMstDiscountType,
                                                                                                    placeholder: "",
                                                                                                    value: optionsMstDiscountType.filter(function(item) {
                                                                                                        return item.value === values.inv_invoice_discounttype;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    isDisabled: true
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    value: NumberFormat(sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2 pt-2",
                                                                                            children: "ภาษีมูลค่าเพิ่ม"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "inv_invoice_vat",
                                                                                            onChange: function(e) {
                                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                    inv_invoice_vat: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowVat(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstVat,
                                                                                            value: optionsMstVat.filter(function(item) {
                                                                                                return item.value === values.inv_invoice_vat;
                                                                                            }),
                                                                                            isDisabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "หัก ณ ที่จ่าย"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "inv_invoice_tax",
                                                                                            onChange: function(e) {
                                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                    inv_invoice_tax: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowTax(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstTax,
                                                                                            value: optionsMstTax.filter(function(item) {
                                                                                                return item.value === values.inv_invoice_tax;
                                                                                            }),
                                                                                            isDisabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowTax, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2 text-end",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white text-end fs-24",
                                                                style: {
                                                                    background: "#B00412",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "row",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "col-6",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-3",
                                                                controlId: "exampleForm.ControlTextarea1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "fw-bold fs-18",
                                                                        children: "หมายเหตุ"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        as: "textarea",
                                                                        rows: 3,
                                                                        value: remark,
                                                                        disabled: true,
                                                                        style: {
                                                                            backgroundColor: "rgb(255 255 255 / 12%)"
                                                                        },
                                                                        onChange: function(e) {
                                                                            return setRemark(e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                disabled: true,
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: docPath.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                to: item.inv_file_url,
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "docfile",
                                                                                    children: /*#__PURE__*/ _jsx("span", {
                                                                                        className: "icon pdf",
                                                                                        children: item.inv_file_url.substring(68)
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id, item);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export function ProductSelect(param) {
    var ref = _object_destructuring_empty(param);
    return /*#__PURE__*/ _jsx(_Fragment, {});
}
export function ProductTableSort(param) {
    var ref = _object_destructuring_empty(param);
    return /*#__PURE__*/ _jsx(_Fragment, {});
}
export function LoadDocument(param) {
    var ref = _object_destructuring_empty(param);
    return /*#__PURE__*/ _jsx(_Fragment, {});
}
export function ProductTableDisplay(param) {
    var ref = _object_destructuring_empty(param);
    return /*#__PURE__*/ _jsx(_Fragment, {});
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsVat = _param.optionsVat, poID = _param.poID, onDeleteProductRow = _param.onDeleteProductRow, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsVat",
        "poID",
        "onDeleteProductRow"
    ]);
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    value: item.inv_detail_name,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_name: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    value: item.inv_detail_unit,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_unit: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF]",
                style: {
                    color: "#666CFF"
                },
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    disabled: true,
                    className: "form-control formv text-center border-0 me-2 !bg-[#EDEDFF]",
                    value: item.inv_detail_amount,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var price = item.inv_detail_discounttype == 1 ? parseFloat((item.inv_detail_price - item.inv_detail_discount) * e.target.value) : parseFloat((item.inv_detail_price - item.inv_detail_price * item.inv_detail_discount / 100) * e.target.value);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_amount: parseInt(e.target.value),
                                        inv_detail_totalprice: parseFloat(price),
                                        inv_detail_net: parseFloat(price + (item === null || item === void 0 ? void 0 : item.inv_detail_vatprice) - (item === null || item === void 0 ? void 0 : item.inv_detail_tax))
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#F6E1E3]",
                style: {
                    color: "#B00412"
                },
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2 !bg-[#F6E1E3]",
                    disabled: true,
                    value: item.inv_detail_price,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var price = item.inv_detail_discounttype == 1 ? parseFloat((e.target.value - item.inv_detail_discount) * item.inv_detail_amount) : parseFloat((e.target.value - e.target.value * item.inv_detail_discount / 100) * item.inv_detail_amount);
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_price: parseFloat(e.target.value),
                                        inv_detail_totalprice: parseFloat(price),
                                        inv_detail_net: parseFloat(price + (item === null || item === void 0 ? void 0 : item.inv_detail_vatprice) - (item === null || item === void 0 ? void 0 : item.inv_detail_tax))
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#F6E1E3]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.inv_detail_discount,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var price = item.inv_detail_discounttype == 1 ? (item.inv_detail_price - e.target.value) * item.inv_detail_amount : (item.inv_detail_price - item.inv_detail_price * e.target.value / 100) * item.inv_detail_amount;
                                    var disPrice = item.inv_detail_discounttype == 1 ? e.target.value : item.inv_detail_price * e.target.value / 100;
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_discount: parseFloat(e.target.value),
                                        inv_detail_discountreal: parseFloat(disPrice),
                                        inv_detail_pricediscount: parseFloat(price),
                                        inv_detail_totalprice: parseFloat(price),
                                        inv_detail_net: parseFloat(price + (item === null || item === void 0 ? void 0 : item.inv_detail_vatprice) - (item === null || item === void 0 ? void 0 : item.inv_detail_tax))
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsxs("select", {
                    value: item.inv_detail_discounttype,
                    disabled: true,
                    style: {
                        width: "100%",
                        border: "0px solid rgb(223, 225, 229)",
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var price = e.currentTarget.value == 1 ? (item.inv_detail_price - item.inv_detail_discount) * item.inv_detail_amount : (item.inv_detail_price - item.inv_detail_price * item.inv_detail_discount / 100) * item.inv_detail_amount;
                                    var disPrice = e.currentTarget.value == 1 ? item.inv_detail_discount : item.inv_detail_price * item.inv_detail_discount / 100;
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_discounttype: parseInt(e.currentTarget.value),
                                        inv_detail_discountreal: parseFloat(disPrice),
                                        inv_detail_pricediscount: parseFloat(price),
                                        inv_detail_totalprice: parseFloat(price),
                                        inv_detail_net: parseFloat(price + (item === null || item === void 0 ? void 0 : item.inv_detail_vatprice) - (item === null || item === void 0 ? void 0 : item.inv_detail_tax))
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกส่วนลด"
                        }, "default"),
                        optionsMstDiscountType && optionsMstDiscountType.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                }) : "-"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? NumberFormat(item.inv_detail_totalprice) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? NumberFormat(item.inv_detail_net) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.inv_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.inv_detail_remark,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        inv_detail_remark: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                style: {
                    width: "20px"
                },
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "btn btn-delete-file ",
                    onClick: function(e) {
                        return onDeleteProductRow(item.rowID, item);
                    },
                    disabled: true
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
